import { useTranslation } from "react-i18next"

const ChooseStory = ({ setChosenStory, alAzarCallback = null, storyList }) => {
  const selectStory = (id) => {
    setChosenStory(id)
  }

  const { t } = useTranslation()

  return (
    <>
      <div className="title">{t(`games.story.select_story`)}</div>
      {storyList && (
        <>
          <div id="category-container" className="container-sm container-mini">
            <div className="row">
              {storyList.map((story, ix) => (
                <div key={ix} className="col-lg-4 col-6 py-1">
                  <div
                    className="box category"
                    onClick={() => selectStory(story.id)}
                  >
                    <span style={{ textAlign: "center" }}>{story.title}</span>
                  </div>
                </div>
              ))}

              {alAzarCallback && (
                <>
                  <div className="col-lg-4 col-6 py-1">
                    <div
                      className="box category azaroso"
                      onClick={alAzarCallback}
                    >
                      <span>{t(`ui.games.btns.quickstart`)}</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ChooseStory
